const NominalTrialBalance = {
  type: 'NominalTrialBalance',
  title: 'Trial Balance',
  formTitle: 'Trial Balance',
  formUrl: '/Nominal/TrialBalance/Form',
  workspaceUrl: '/menu/Nominal',
  screenReference: 'NOMINAL_TRIALBALANCE',
  actions: [
    {
      description: 'View Trial Balance',
    },
    {
      description: 'Print Trial Balance',
    },
  ],
  operations: 0,
};

export default NominalTrialBalance;
